// Help article for DYMO label printing. Points at the top of the article for
// now; once the bulk printing section from ENG-1867 is live, point it at that
// section's anchor instead.
export const LABELS_HELP_URL =
  "https://docs.monolithforensics.com/monolith/using-monolith/hardware-integrations/dymo-label-printers";

// The Print Labels dialog banner's dismissal key (ENG-2241). Bump the version
// when the copy changes enough that users who closed it should see it again.
export const PRINT_LABELS_BANNER_ID = "print-labels:v1";
